<template>
  <el-dialog
    title="排除商品"
    width="768px"
    :visible="showModal"
    :mask-closable="false"
    @close="handleCancel"
    draggable
    :body-style="{ padding: '0px' }"
  >
    <div class="excludeProductContent">
      <bi-tip>
        <div>
          说明：1.将小样、赠品进行打标，后续在报表中直接选择标签即可进行排除
        </div>
        <div>
          2.排除说明：仅排除打标商品的金额和件数，如订单中仅含有打标商品，则整单均会被排除，单量、金额、件数均不会被统计
        </div>
      </bi-tip>
      <div class="selectTagBox" v-loading="loading">
        <el-form ref="formData" inline label-width="auto">
          <el-form-item label="选择标签:" required>
            <bi-button type="blueText" @click="toCreateTag"
              >+ 创建标签</bi-button
            >
            <bi-button type="blueText"
             @click="handleRefresh"
              >刷新</bi-button
            >
          </el-form-item>
          <div class="tagSelectBox">
            <div class="tagSelectList">
              <div class="tagSelectItem" v-for="item in tagList" :key="item.id">
                <div class="bi-title">
                  {{ item.name }}
                  <el-checkbox 
                    :label="item.id"
                    v-model="groupSelected"
                    class="groupCheck"
                    @change="handleGroupSelect(item, $event)"
                  >
                    全选
                  </el-checkbox>
                </div>
                <div class="tagBox">
                  <div
                    class="tagItem"
                    :class="{ active: selectedTagIds.includes(tag.id) }"
                    v-for="tag in item.itemTagList"
                    :key="tag.id"
                    @click="handleTagClick(tag)"
                  >
                    {{ tag.name }}
                    <img
                      v-if="selectedTagIds.includes(tag.id)"
                      src="@/assets/images/selectTag.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <template #footer>
      <div class="footerBtnBox">
        <el-checkbox v-model="localChecked">
          <span class="checkText">应用于全局</span>
        </el-checkbox>
        <span>
          <bi-button @click="handleSure" type="blue">确定</bi-button>
          <bi-button @click="handleCancel" type="gley">取消</bi-button>
        </span>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "ExcludeProductDialog",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    checked: {
      type: Boolean,
      default: true,
    },
    tagList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedTagIds: [],
      groupSelected: [],
      loading: false,
    };
  },
  computed: {
    localChecked: {
      get() {
        return this.checked;
      },
      set(val) {
        this.$emit("update:checked", val);
      },
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.selectedTagIds = cloneDeep(this.value);
        this.updateGroupSelected();
      }
    },
    selectedTagIds: {
      handler() {
        this.updateGroupSelected();
      },
      deep: true,
    },
  },
  async mounted() {
    this.$emit("initExclude", "exclude");
  },
  methods: {
    toCreateTag() {
      if (window.location.origin.includes("yqbi.yucrm.cn")) {
        window.open(
          "https://yqbi.yucrm.cn/bi-web/yunzhou-common/system-redirect?redirectUrl=/data_management/item_manage",
          "_blank",
        );
      } else {
        window.open(
          "http://yqbi-test.yucrm.cn/bi-web/yunzhou-common/system-redirect?redirectUrl=/data_management/item_manage",
          "_blank",
        );
      }
      return;
    },
    async handleSure() {
      this.$emit("update:showModal", false);
      this.$emit("confirm", this.selectedTagIds);
    },
    handleRefresh() {
      this.$emit("initExclude");
    },
    handleTagClick(tag) {
      const index = this.selectedTagIds.indexOf(tag.id);
      if (index > -1) {
        this.selectedTagIds.splice(index, 1);
      } else {
        this.selectedTagIds.push(tag.id);
      }
    },
    handleGroupSelect(item, checked) {
      const tagIds = item.itemTagList.map(tag => tag.id);
      if (checked) {
        tagIds.forEach(id => {
          if (!this.selectedTagIds.includes(id)) {
            this.selectedTagIds.push(id);
          }
        });
      } else {
        this.selectedTagIds = this.selectedTagIds.filter(id => !tagIds.includes(id));
      }
    },
    updateGroupSelected() {
      this.groupSelected = this.tagList
        .filter(item => {
          if (!item.itemTagList || item.itemTagList.length === 0) return false;
          return item.itemTagList.every(tag => this.selectedTagIds.includes(tag.id));
        })
        .map(item => item.id);
    },
    handleCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: PingFang SC, PingFang SC;
}
.footerBtnBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .checkText {
    color: #666666;
    font-weight: 400;
  }
}
.selectTagBox {
  margin-top: 20px;
  margin-bottom: 6px;
  .tagSelectBox {
    margin-left: 80px;
    background-color: #f9f9fb;
    padding: 20px;

    .tagSelectList {
      overflow: auto;
      height: 300px;
      .tagSelectItem {
        .tagBox {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-bottom: 16px;
          .tagItem {
            position: relative;
            display: inline-flex;
            line-height: 1;
            justify-content: center;
            align-items: center;
            padding: 6px 24px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #dbdbdb;
            &:hover,
            &.active {
              border: 1px solid #3159ff;
              color: #3159ff;
              background-color: #f4f6ff;
              cursor: pointer;
            }
            img {
              width: 15px;
              height: 15px;
              position: absolute;
              bottom: 0;
              right: -1px;
            }
          }
        }
      }
    }
  }
}
.bi-title {
  position: relative;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  text-align: left;
  padding-left: 10px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &::after {
    content: "";
    left: 0px;
    top: 3px;
    position: absolute;
    display: inline-block;
    width: 2px;
    height: 14px;
    background: #2768ff;
    border-radius: 1px;
  }
  .groupCheck {
    margin-left: 10px;
    font-weight: normal;
    font-size: 12px;
    color: #666666;
  }
}
</style>
